import API from "../index";
import {API_GET_UNFINISHED} from "../../constants/api";

async function getUnfinished(currentPage, pageSize, filters = {}, sort = {}) {
  const headers = {
    "Content-Type": "application/json; charset=UTF-8",
  };
  try {
    const data = {
      page: currentPage,
      per_page: pageSize,
      ...filters,
      sort: sort,
    };
    const response = await API.get(
      API_GET_UNFINISHED,
      { params: data },
      { headers }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
}

export { getUnfinished };